import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../Common/tokenDecoder';

export default {
    saveEstatePackageCreation,
    editData,
    GetAllCollectionPoints,
    GetAllCardsByCollectionPointID,
    getAvailableUsers,
    getAllOperationEntitiesForDropDown,
    getOperationEntityByID,
    getCollectionPointByOperationEntityId,
    getEstatePackageFilterData,
    editDataIfSOSTrue,
    GetCollectionPointForPackage,
    getEstatesByGroupID
};

async function saveEstatePackageCreation(data) {
    let packages = {
        packageID: 0,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        operationalCardID: parseInt(data.operationalCardID),
        aspNetUserId: parseInt(data.aspNetUserId),
        packageCode: data.packageCode,
        packageName: data.packageName.trim(),
        password: data.backupLoginPassword,
        noOfSessions: parseInt(data.noOfSessions),
        isActive: data.isActive,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Package/AddEstatePackage', null, packages);
    return response;
}

async function editData(data) {
    let packages = {
        packageID: data.packageID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        operationalCardID: parseInt(data.operationalCardID),
        aspNetUserId: data.aspNetUserId === "-1" ? null : parseInt(data.aspNetUserId),
        packageCode: data.packageCode,
        packageName: data.packageName.trim(),
        password: data.backupLoginPassword,
        noOfSessions: parseInt(data.noOfSessions),
        isActive: data.isActive,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/Package/UpdateEstatePackage', null, packages);
    return response;

}

async function editDataIfSOSTrue(packageID) {
    const response = await CommonGet('/api/SoS/CheckSoSStateByPackageId', 'packageID=' + packageID);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(id) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetCollectionPointForPackage(id, groupID) {
    var objModel = {
        groupID: groupID,
        operationEntityID: id,
        collectionPointID: ""
    }
    var collectionPointArray = [];
    const response = await CommonPost('/api/CollectionPoint/GetCollectionPointsForPackage', null, objModel);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return collectionPointArray;
}

async function getEstatePackageFilterData(data) {
    var filtermodel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        collectionPointID: data.collectionPointID
    }
    const response = await CommonPost('/api/Package/FilterEstatePackage', null, filtermodel);
    return response.data;

}

async function GetAllCardsByCollectionPointID(collectionPointID, operationalCardID) {
    var cardsArray = [];
    let cardFilterModel = {
        collectionpointID: collectionPointID.toString(),
        cardID: operationalCardID.toString()
    };
    const response = await CommonPost('/api/Card/GetAvailabaleOperationCardsForPackages', null, cardFilterModel);
    for (let item of Object.entries(response.data)) {
        cardsArray[item[1]["cardID"]] = item[1]["nameToBePrinted"]
    }
    return cardsArray;
}

async function getAvailableUsers(operationEntityID, userID) {
    if (operationEntityID != '0') {

        var usersArray = [];
        let userFilterModel = {
            operationEntityID: operationEntityID.toString(),
            userID: userID.toString()
        }

        var response = await CommonPost('/api/Package/GetAvailableUsersForPackage', null, userFilterModel);
        for (let item of Object.entries(response.data)) {
            usersArray[item[1]["aspNetUserId"]] = item[1]["userName"]
        }
        return usersArray;
    }
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getOperationEntityByID(operationEntityID) {
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByID', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function getCollectionPointByOperationEntityId(data) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: data.operationEntityID,
        groupID: data.groupID
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel /*'operationEntityId=' + operationEntityID, "groupID" + groupID*/);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}

async function getEstatesByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}


